var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClockInIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 153,
    viewBox: "0 0 150 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75 150C116.421 150 150 116.421 150 75C150 33.5786 116.421 0 75 0C33.5786 0 0 33.5786 0 75C0 116.421 33.5786 150 75 150Z",
    fill: "url(#paint0_linear_585_6402)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_585_6402)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_585_6402",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 150,
    height: 150
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75 150C116.421 150 150 116.421 150 75C150 33.5786 116.421 0 75 0C33.5786 0 0 33.5786 0 75C0 116.421 33.5786 150 75 150Z",
    fill: "url(#paint1_linear_585_6402)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_585_6402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118 43H32C29.2386 43 27 45.2386 27 48V153C27 155.761 29.2386 158 32 158H118C120.761 158 123 155.761 123 153V48C123 45.2386 120.761 43 118 43Z",
    fill: "white"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66 53H40C38.3431 53 37 54.3431 37 56C37 57.6569 38.3431 59 40 59H66C67.6569 59 69 57.6569 69 56C69 54.3431 67.6569 53 66 53Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66 95H40C38.3431 95 37 96.3431 37 98C37 99.6569 38.3431 101 40 101H66C67.6569 101 69 99.6569 69 98C69 96.3431 67.6569 95 66 95Z",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M108 68H42C39.7909 68 38 69.7909 38 72V82C38 84.2091 39.7909 86 42 86H108C110.209 86 112 84.2091 112 82V72C112 69.7909 110.209 68 108 68Z",
    stroke: "#A6F4C5",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M108 109H42C39.2386 109 37 111.239 37 114V122C37 124.761 39.2386 127 42 127H108C110.761 127 113 124.761 113 122V114C113 111.239 110.761 109 108 109Z",
    fill: "#E6E6E6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60 23C60 24.933 58.433 26.5 56.5 26.5C54.567 26.5 53 24.933 53 23C53 21.067 54.567 19.5 56.5 19.5C58.433 19.5 60 21.067 60 23Z",
    fill: "white",
    stroke: "#A8A8A8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M79 23C79 24.933 77.433 26.5 75.5 26.5C73.567 26.5 72 24.933 72 23C72 21.067 73.567 19.5 75.5 19.5C77.433 19.5 79 21.067 79 23Z",
    fill: "white",
    stroke: "#A8A8A8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M98 23C98 24.933 96.433 26.5 94.5 26.5C92.567 26.5 91 24.933 91 23C91 21.067 92.567 19.5 94.5 19.5C96.433 19.5 98 21.067 98 23Z",
    fill: "white",
    stroke: "#A8A8A8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1064 74.5209C82.1252 75.114 80.0251 73.9894 79.4293 71.9989C78.8334 70.0085 79.9729 67.9242 81.954 67.3311C83.9352 66.7381 86.0353 67.8627 86.6311 69.8531C87.227 71.8435 86.0875 73.9278 84.1064 74.5209ZM82.3717 68.7263C81.1625 69.0883 80.4625 70.3721 80.8272 71.5906C81.192 72.809 82.473 73.4998 83.6915 73.135C84.9099 72.7703 85.6007 71.4892 85.2359 70.2708C84.8712 69.0523 83.5808 68.3643 82.3717 68.7263Z",
    fill: "#667085"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4986 82.5105C85.1221 82.9226 83.5803 82.8166 82.1923 82.1072C78.6577 80.2871 74.3642 76.9814 74.0074 71.6256C73.6783 66.7683 77.0401 63.5424 80.5094 62.5039C80.5094 62.5039 80.5094 62.5039 80.5187 62.5011C83.988 61.4625 88.5694 62.3105 90.9662 66.559C93.6017 71.2326 91.8281 76.3444 89.875 79.8073C89.1051 81.1627 87.8752 82.0985 86.4986 82.5105ZM80.9271 63.899C78.2204 64.7093 75.1734 67.1923 75.4666 71.5233C75.7735 76.2048 79.6571 79.1569 82.8654 80.801C84.9395 81.8726 87.4601 81.118 88.6042 79.0831C90.372 75.9492 91.9947 71.3488 89.6973 67.2631C87.5532 63.4863 83.6337 63.0888 80.9271 63.899Z",
    fill: "#667085"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9071 104.37C89.1071 104.37 88.3601 104.37 87.6801 104.327C86.8425 104.27 86.0367 103.984 85.3515 103.499C84.6662 103.014 84.128 102.349 83.7961 101.578L79.5771 93.24C79.2676 92.8797 79.1131 92.4117 79.1472 91.938C79.1813 91.4643 79.4012 91.0233 79.7591 90.711C80.0522 90.4754 80.418 90.3485 80.7941 90.352C81.071 90.3601 81.3428 90.4281 81.5909 90.5513C81.839 90.6746 82.0574 90.8502 82.2311 91.066L84.1471 93.681L84.1761 93.715V83.78C84.1761 83.2871 84.3719 82.8144 84.7204 82.4659C85.069 82.1173 85.5417 81.9215 86.0346 81.9215C86.5275 81.9215 87.0002 82.1173 87.3487 82.4659C87.6973 82.8144 87.8931 83.2871 87.8931 83.78V90.28C87.8715 90.0408 87.9 89.7998 87.9767 89.5722C88.0534 89.3446 88.1767 89.1355 88.3387 88.9582C88.5007 88.781 88.6979 88.6394 88.9176 88.5425C89.1374 88.4456 89.3749 88.3956 89.6151 88.3956C89.8552 88.3956 90.0928 88.4456 90.3125 88.5425C90.5323 88.6394 90.7294 88.781 90.8914 88.9582C91.0534 89.1355 91.1767 89.3446 91.2535 89.5722C91.3302 89.7998 91.3587 90.0408 91.3371 90.28V91.635C91.3155 91.3958 91.344 91.1548 91.4207 90.9272C91.4974 90.6996 91.6207 90.4905 91.7827 90.3132C91.9447 90.136 92.1419 89.9944 92.3616 89.8975C92.5814 89.8006 92.8189 89.7506 93.0591 89.7506C93.2992 89.7506 93.5368 89.8006 93.7565 89.8975C93.9763 89.9944 94.1734 90.136 94.3354 90.3132C94.4974 90.4905 94.6207 90.6996 94.6975 90.9272C94.7742 91.1548 94.8027 91.3958 94.7811 91.635V92.679C94.7595 92.4398 94.788 92.1988 94.8647 91.9712C94.9414 91.7436 95.0647 91.5345 95.2267 91.3572C95.3887 91.18 95.5859 91.0384 95.8056 90.9415C96.0254 90.8446 96.2629 90.7946 96.5031 90.7946C96.7432 90.7946 96.9808 90.8446 97.2005 90.9415C97.4203 91.0384 97.6174 91.18 97.7794 91.3572C97.9414 91.5345 98.0647 91.7436 98.1415 91.9712C98.2182 92.1988 98.2467 92.4398 98.2251 92.679V99.016C98.1911 100.965 97.3101 104.251 94.2111 104.251C93.9861 104.261 92.0801 104.371 89.9111 104.371L89.9071 104.37Z",
    fill: "#6CE9A6",
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_585_6402",
    x: 21,
    y: 34,
    width: 108,
    height: 119,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.803922 0 0 0 0 0.85098 0 0 0 0.349 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_585_6402"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_585_6402",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_585_6402",
    x1: 75,
    y1: 0,
    x2: 75,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E2E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_585_6402",
    x1: 75,
    y1: 0,
    x2: 75,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E0E0"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockInIllustration);
export default __webpack_public_path__ + "static/media/clockInIllustration.3c69123c56a17ae51ffe1742a56260f4.svg";
export { ForwardRef as ReactComponent };